import { render, staticRenderFns } from "./userProfileEdit.vue?vue&type=template&id=61075817&scoped=true"
import script from "./userProfileEdit.vue?vue&type=script&lang=js"
export * from "./userProfileEdit.vue?vue&type=script&lang=js"
import style0 from "./userProfileEdit.vue?vue&type=style&index=0&id=61075817&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61075817",
  null
  
)

export default component.exports